import type { ReactNode } from "react";
import { useAuth } from "#/context/AuthProvider";

export function MembershipAccess({
  children,
  permissions = [],
  roles = ["ADMIN", "SUPER_ADMIN"],
  fallback = null,
}: {
  children: ReactNode;
  permissions?: string[];
  roles?: string[];
  fallback?: ReactNode;
}) {
  const { hasAnyRole, hasAnyPermission } = useAuth();

  const allowed =
    hasAnyRole(roles) || (permissions.length > 0 && hasAnyPermission(permissions));

  return allowed ? <>{children}</> : <>{fallback}</>;
}